{
	"ID": 7,
	"fields": {
		"isGUID": true,
		"isAgentNumber": true,
		"isPartition": true,
		"isDescription": true,
		"advanced": {
			"isCallCentreLicenceType": true,
			"isInternalNumber": true,
			"isCiscoCommonID": false,
			"isOverrideMonitoring": true,
			"isWebexCallingUserID": false,
			"isBroadworksUserID": true,
			"isOwningGroupID": true,
			"isOidOnTelServer": false,
			"isOwningDepartment": true,
			"isTeamsUserID": false,
			"isUserPrincipalName": false
		},
		"omnichannel": {
			"isAllowAnsweringConcurrentChannels": true,
			"chatIntegration": {
				"isType": true,
				"isId": true
			},
			"emailIntegration": {
				"isType": true,
				"isEmailAddress": true,
				"isId": true
			}
		},
		"isUpdateDuplicateItems": true
	}
}